<template>

  <template v-for="node of nodes">
    <template v-if="node.children.length === 0">
      <li class="theme" v-if="isSelectedTheme(node)">{{ node.theme.title }}</li>
    </template>
    <template v-if="node.children.length > 0">
      <template v-if="hasDirectSelectedLeaf(node.children) || hasSelectedInThemes(node.children)">
        <template v-if="hasDirectSelectedLeaf(node.children)">
          <span class="root"> {{ getBreadCrumbForTheme(node.theme) }}</span>
          <ul class="theme-list theme-list-padding">
            <theme-display v-bind:themes="themes" v-bind:nodes="node.children.filter(c => entityThemes.findIndex(id => id === c.theme.id) > -1)"
                           v-bind:entity-themes="entityThemes"></theme-display>
          </ul>
        </template>
        <ul class="theme-list">
          <theme-display v-if="hasSelectedInThemes(node.children)" v-bind:themes="themes"
                         v-bind:nodes="node.children.filter(c => entityThemes.findIndex(id => id === c.theme.id) === -1)"
                         v-bind:entity-themes="entityThemes"></theme-display>
        </ul>

      </template>
    </template>

  </template>
</template>
<script lang="ts">

import {Options, Vue} from "vue-class-component";
import {ThemeTreeNode} from '@/entities/ThemeTree';
import {PropType} from 'vue';
import {isDefined} from '@/utils';
import {Theme} from '@/entities/Theme';

@Options({
  components: {ThemeDisplay},
  props: {
    nodes: {
      default: undefined,
      required: true,
      type: Array as PropType<Array<ThemeTreeNode>>
    },
    themes: {
      default: [],
      required: true,
      type: Array as PropType<Array<Theme>>
    },
    entityThemes: {
      default: [],
      required: true,
      type: Array as PropType<Array<String>>
    }
  }
})
export default class ThemeDisplay extends Vue {

  private themes: Theme[];
  private entityThemes: String[];

  constructor(props) {
    super(props);
  }

  public isSelectedTheme(node: ThemeTreeNode): boolean {
    return this.entityThemes.findIndex(id => id === node.theme.id) > -1;

  }

  public hasDirectSelectedLeaf(nodes: ThemeTreeNode[]): boolean {
    for (const node of nodes) {
      if (this.entityThemes.findIndex(id => id === node.theme.id) > -1) {
        return true;
      }
    }
    return false;
  }

  public hasSelectedInThemes(nodes: ThemeTreeNode[]): boolean {
    for (const node of nodes) {
      if (this.entityThemes.findIndex(id => id === node.theme.id) > -1) {
        return true;
      }
      if (node.children.length > 0) {
        if (this.hasSelectedInThemes(node.children)) {
          return true;
        }
      }
    }
    return false;
  }

  public getThemeById(id): Theme {
    return this.themes.find(v => v.id === id);
  }

  public getBreadCrumbForTheme(theme: Theme): string {
    let breadCrumb = '';
    if (isDefined(theme)) {
      breadCrumb = theme.title;
      if (theme.parentId !== 'ROOT') {
        theme = this.getThemeById(theme.parentId);
        while (theme !== undefined && theme.parentId !== 'ROOT') {
          breadCrumb = `${theme.title} >> ${breadCrumb}`;
          theme = this.getThemeById(theme.parentId);
        }
      }
    }
    return breadCrumb;
  }


}
</script>

<style scoped lang="scss">


.root {
  text-align: left;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 12px;
  margin-top: 12px;
  display: block;
}


.theme-list {
  margin: 6px 0 0 0;
  padding-left: 0;
  list-style-type: disc !important;

}

.theme {
  text-align: left;
  font-size: 1rem;
  margin-left: 24px;
  font-weight: normal;
}

.theme-list-padding {
  padding-left: 15px;
}


</style>
